'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { toMoment } from 'UIComponents/core/SimpleDate';

const getStringFromSimpleDate = date => {
  return toMoment(date).format('L');
};

const ScheduleSummary = ({
  schedule
}) => {
  if (!schedule) {
    return null;
  }

  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Small, {
      children: schedule.endDate ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.summary.schedule.hasEndDate",
        options: {
          startString: getStringFromSimpleDate(schedule.startDate),
          endString: getStringFromSimpleDate(schedule.endDate)
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.summary.schedule.noEndDate",
        options: {
          startString: getStringFromSimpleDate(schedule.startDate)
        }
      })
    })
  });
};

export default ScheduleSummary;